<template>
  <base-bottom-sheet-list-card v-bind="$attrs" v-on="$listeners">
    <template #top>
      <product-detail-size-table
        dialog-class="elevation-0"
        activator-class="white--text text-body-3 mb-5 ml-5"
      ></product-detail-size-table>
    </template>

    <template #item="item">
      <v-list-item-action-text
        class="text-h5"
        :class="[
          item.available ? 'grey-darken-4--text' : 'grey-darken-1--text',
        ]"
        style="min-width: 50px"
      >
        {{ item.size }}
      </v-list-item-action-text>
      <v-list-item-content
        class="text-body-3"
        :class="[
          item.available ? 'grey-darken-4--text' : 'grey-darken-1--text',
        ]"
      >
        {{ item.text }}
      </v-list-item-content>
      <v-list-item-action-text
        v-if="item.lowStock && item.available"
        class="pink-berry--text"
      >
        {{ $t('commons.lowStock') }}
      </v-list-item-action-text>
    </template>
  </base-bottom-sheet-list-card>
</template>

<script>
import BaseBottomSheetListCard from '~/components/base/bottomSheet/BaseBottomSheetListCard'
import ProductDetailSizeTable from '~/components/product/detail/ProductDetailSizeTable'

export default {
  name: 'ProductConfiguratorSizeBottomSheet',
  components: {
    ProductDetailSizeTable,
    BaseBottomSheetListCard,
  },
}
</script>
